import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled from 'styled-components';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: center;
  color: var(--grey700);
`;
export const ServiceTypeColumn = ({ ticket }) => {
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.SERVICE}
    >
      <CustomRegularText>{ticket.order_data.service_type.vehicle_type}</CustomRegularText>
    </BodyColumn>
  );
};
